import { render, staticRenderFns } from "./DashboardClarenceFull.vue?vue&type=template&id=22fff417&scoped=true"
import script from "./DashboardClarenceFull.vue?vue&type=script&lang=js"
export * from "./DashboardClarenceFull.vue?vue&type=script&lang=js"
import style0 from "./DashboardClarenceFull.vue?vue&type=style&index=0&id=22fff417&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22fff417",
  null
  
)

export default component.exports